export const APP_VERSION = 'v2026.11.03.0276';
// Auto-updated or maintained version string for Arena UI & Cache busting
export const ARENA_VERSION = 'v5.0.364';
export const ARENA_BUILD_ID = 'build-20261103.0016';
